// extracted by mini-css-extract-plugin
export var childrenContainer = "_al-0";